// extracted by mini-css-extract-plugin
module.exports = {"content":"content-lFQ5L","name":"name-1MryT","iata":"iata-2plOC"};